class PdpAccountModal extends HTMLElement {
  constructor() {
    super()

    this.loginForm = this.querySelector('.customer-login')
    this.resetForm = this.querySelector('.customer-reset')
    this.closeButton = this.querySelector('.close-login')

    this.closeButton.addEventListener('click', this.close.bind(this))

    this.init()
  }

  init() {
    this.addEventListener('click', (event) => {
      const { target } = event
      const ancestor = target.closest('.customer-inner-wrapper')

      if (!ancestor) {
        this.close()
      }
    })
  }

  close() {
    this.closest('.customer-wrapper').classList.remove('shown')
    setTimeout( () => {
      this.closest('.customer-wrapper').classList.remove('visible')
    }, 450)
  }
}

customElements.define("wishlist-login", PdpAccountModal)